import React, { useEffect } from "react";
import "react-responsive-modal/styles.css";
import { Modal } from "react-responsive-modal";
import { useForm } from "react-hook-form";
import { useAddEmployeeESI } from "../../../queries/employeeQueries";
import { toast } from "react-toastify";
import { ESIRegex } from "../../../utils/regex/regex";
// ESI: 10 to 17-digit numeric
const EditOrAddESI = ({ openModal, onCloseModal, employee }) => {
  const { mutate: addOrEditEmployeeESI, isLoading } = useAddEmployeeESI();

  const {
    register,
    handleSubmit,
    reset,
    setValue,
    setError,
    formState: { errors },
  } = useForm();

  const esiDetails = employee?.esiDetails || {};

  useEffect(() => {
    if (openModal) {
      reset({
        esi_number: esiDetails?.esi_number || "",
        status: !!esiDetails?.status,
      });
    }
  }, [openModal, esiDetails, reset]);

  const onSubmit = (data) => {
    const payload = {
      employee_id: employee?.employee_id,
      esi_number: data.esi_number.trim(),
      status: !!data.status,
    };

    addOrEditEmployeeESI(payload, {
      onSuccess: (res) => {
        toast.success("ESI details saved successfully");
        onCloseModal();
      },
      onError: (error) => {
        const validations = error?.response?.data?.validations;

        if (validations && Array.isArray(validations)) {
          validations.forEach((validation) => {
            setError(validation.param, {
              message: validation.msg,
            });
          });
        } else {
          toast.error(error?.message || "Failed to save ESI details");
        }
      },
    });
  };

  return (
    <Modal open={openModal} onClose={onCloseModal} center>
      <div className="p-5 w-[380px]">
        <h2 className="text-lg text-[#1F2937] font-semibold mb-5">
          Edit/Add ESI
        </h2>
        <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
          <div className="w-full">
            <label className="text-sm font-medium text-black">
              ESI Insurance Number <span className="text-red-700">*</span>
            </label>
            <input
              type="text"
              className="h-[38px] w-full border border-gray-300 rounded px-2 mt-1"
              {...register("esi_number", {
                required: "ESI number is required",
                pattern: {
                  value: ESIRegex,
                  message: "ESI number must be 10 to 17 digits",
                },
              })}
            />
            {errors.esi_number && (
              <p className="text-sm text-red-600 mt-1">
                {errors.esi_number.message}
              </p>
            )}
          </div>

          <div className="flex items-center gap-2 mt-2">
            <input type="checkbox" {...register("status")} />
            <label className="text-sm text-black">Enable ESI</label>
          </div>

          <div className="flex justify-end gap-3 mt-6">
            <button
              type="button"
              className="btn btn--border text-sm font-medium"
              onClick={onCloseModal}
              disabled={isLoading}
            >
              Cancel
            </button>
            <button
              type="submit"
              className="btn text-sm font-medium"
              disabled={isLoading}
            >
              {isLoading ? "Saving..." : "Save Changes"}
            </button>
          </div>
        </form>
      </div>
    </Modal>
  );
};

export default EditOrAddESI;
